import { MNSproCloudApi } from '../..';
import { ReportAvailable } from '../../api/v2';

export interface AvailableClassbookExport {
  name: string;
  timePeriod: string;
  classId: string;
  className: string;
  created: {
    at: string;
    by: {
      id: string;
      displayName: string;
      mailAddress: string;
    };
  };
}

export class ClassbookExportService {
  private constructor() {}

  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterExportApiFactory(config);
    return api;
  }

  public static async getAvailable(
    authToken: string,
    organizationId: string,
  ): Promise<ReportAvailable[]> {
    const api = ClassbookExportService.getApi(authToken);
    const response = await api.getReportsAvailable(organizationId);

    return response.data;
  }

  public static async create(
    authToken: string,
    organizationId: string,
    timePeriod: string,
    classId: string,
  ) {
    const api = ClassbookExportService.getApi(authToken);
    const response = await api.createReport(
      organizationId,
      timePeriod,
      classId,
    );
    return response.data;
  }

  public static async download(
    authToken: string,
    organizationId: string,
    name: string,
  ) {
    const api = ClassbookExportService.getApi(authToken);
    const response = await api.downloadReport(organizationId, name);
    return response.data;
  }
}
